export var ComboBoxRequestStatus;

(function (ComboBoxRequestStatus) {
  ComboBoxRequestStatus[ComboBoxRequestStatus["Pending"] = 0] = "Pending";
  ComboBoxRequestStatus[ComboBoxRequestStatus["Success"] = 1] = "Success";
  ComboBoxRequestStatus[ComboBoxRequestStatus["Failed"] = 2] = "Failed";
  ComboBoxRequestStatus[ComboBoxRequestStatus["Unknown"] = 3] = "Unknown";
})(ComboBoxRequestStatus || (ComboBoxRequestStatus = {}));